import { render } from "./ModelTitle.vue?vue&type=template&id=573d9aa8"
import script from "./ModelTitle.vue?vue&type=script&lang=js"
export * from "./ModelTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__